<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-img
        :src="require('@/assets/square-logo.png')"
        contain
        max-width="128"
        min-height="78"
        width="100%"
        class="logo-filter"
      />

      <base-title size="body-1" space="4" title="" weight="regular" />

      <base-body>
        Is a consulting company providing accounting services and technology
        solutions. We stand beside all businesses to help them shape and drive
        their transformation journey. We are always at the forefront of
        innovation.
      </base-body>
      <base-btn class="mb-12" color="white" outlined href="/privacy-policy">
        Privacy Policy
      </base-btn>
      <br />
      <base-btn
        class="mb-12"
        color="white"
        outlined
        href="https://kenwyn-accounting.blogspot.com"
        target="_blank"
      >
        Blog
      </base-btn>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseInfo",

  props: {
    title: String,
    dark: Boolean
  },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text: "785D Woodlands Rise, <br> #02-60 Singapore,<br> 734785"
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "+94-26 205 5830"
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "info@kenwynaccounting.com"
      }
    ]
  })
};
</script>

<style scoped>
.logo-filter {
  filter: grayscale(100%);
}
</style>
